import type { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const AdvisorKeys = {
	all: ["activities"] as const,
	agent: (id: number) => [...AdvisorKeys.all, "agent", id] as const,
	assigned: (filterStatus?: UserAgentStatusEnum) =>
		[...AdvisorKeys.all, "assigned", filterStatus] as const,
};
